export const STATUS_DRAFT_DESC = 'Draft';
export const STATUS_DRAFT_ID = 1;
export const STATUS_SUBMITTED_DESC = 'Submitted';
export const STATUS_SUBMITTED_ID = 2;
export const IMO_FAL_FORM_3_MODEL = 'imofalform3';
export const IMO_FAL_FORM_1_MODEL = 'imofalform1';
